import { Component, Input } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NzCollapseModule } from "ng-zorro-antd/collapse";
import { CoreDisputeType } from "@handshake/core-types";

@Component({
  selector: "app-core-dispute-resolution-guide",
  standalone: true,
  imports: [CommonModule, NzCollapseModule],
  templateUrl: "./core-dispute-resolution-guide.component.html",
})
export class CoreDisputeResolutionGuideComponent {
  /** When false (ID structure projects), hide CaseTrust mediation naming/links. */
  @Input() showCaseTrustBrand = true;

  readonly DisputeType = CoreDisputeType;
  readonly panels = [
    {
      id: CoreDisputeType.INITIAL_ATTEMPT,
      name: "Step 1: Initial Resolution Attempts (Strongly Recommended)",
    },
    {
      id: CoreDisputeType.MEDIATION,
      name: "Step 2: Mediation (Third-Party Assisted Resolution)",
    },
    {
      id: CoreDisputeType.ARBITRATION,
      name: "Step 3: Arbitration (Binding Third-Party Decision)",
    },
    {
      id: CoreDisputeType.LITIGATION,
      name: "Step 4: Litigation",
    },
  ];
}
